<template>
  <div>
    <!-- 我的课件 -->
    <template v-if="type === 1">
      <div class="se-flex jcsb aic">
        <div class="ft-22-333">我上传的课程</div>
        <div class="se-start-test cp" @click="uploadCourse">上传课件</div>
        <!-- type = 3 -->
      </div>
      <div class="se-flex se-m-t-20 se-m-b-20">
        <div
          :class="[
            'se-btn',
            'cp',
            'ft-16-333',
            'se-m-r-25',
            activeIndex == index ? 'active' : '',
          ]"
          v-for="(item, index) in tabs"
          :key="index"
          @click="changeTab(item, index)"
        >
          {{ item.name }}
        </div>
        <!-- <div
          :class="[
            'se-btn',
            'cp',
            'ft-16-333',
            'se-m-r-25',
            index === 1 ? 'active' : '',
          ]"
          @click="index = 1"
        >
          待审核
        </div>
        <div
          :class="[
            'se-btn',
            'cp',
            'ft-16-333',
            'se-m-r-25',
            index === 2 ? 'active' : '',
          ]"
          @click="index = 2"
        >
          审核通过
        </div>
        <div
          :class="['se-btn', 'cp', 'ft-16-333', index === 3 ? 'active' : '']"
          @click="index = 3"
        >
          审核驳回
        </div> -->
      </div>
      <div class="se-list se-p-t-10" v-loading="loading">
        <div
          class="se-item se-flex jcsb aic"
          v-for="(item, i) in courseFiles"
          :key="i"
        >
          <div class="se-flex" style="align-items: center">
            <img
              :src="
                item.coverUrl
                  ? item.coverUrl
                  : require('../../../assets/images/studyC.png')
              "
              style="width: 160px; height: 140px; object-fit: cover"
            />
            <div class="se-m-l-20">
              <div class="ft-16-333-b se-m-b-10">{{ item.courseName }}</div>
              <div class="ft-14-999 se-m-b-30">
                上传时间：{{ item.createdTime }}
              </div>

              <!-- <img
                src="../../../assets/icons/kj1.png"
                style="width: 65px; height: 28px"
              /> -->
              <div
                class="se-flex aic ft-14-666 se-p-b-20"
                style="white-space: nowrap"
              >
                <div>点击量：{{ item.statisticalChartVo.totalClickCount }}</div>
                <div class="se-dot"></div>
                <div>
                  平均浏览时长：{{ item.statisticalChartVo.avgDuration }}
                </div>
                <div class="se-dot"></div>
                <div>浏览完毕量：{{ item.statisticalChartVo.endNum }}</div>
                <div class="se-dot"></div>
                <div>评价数：{{ item.statisticalChartVo.evaluateNum }}</div>
              </div>
              <div class="course-status">
                <div v-if="item.auditStatus === 0" class="auditStatus-0">
                  无需审核
                </div>
                <div v-if="item.auditStatus === 1" class="auditStatus-1">
                  待审核
                </div>
                <div v-if="item.auditStatus === 2" class="auditStatus-2">
                  审核驳回
                </div>
                <div v-if="item.auditStatus === 3" class="auditStatus-3">
                  审核通过
                </div>
                <!-- <img
                  v-else
                  :src="
                    require(`../../../assets/status/auditStatus-${item.auditStatus}.png`)
                  "
                  alt=""
                /> -->
              </div>
              <!-- <div v-if="item.auditStatus == 1">待审核</div>
              <div v-if="item.auditStatus == 2">审核驳回</div>
              <div v-if="item.auditStatus == 3">审核通过</div> -->
            </div>
          </div>
          <div class="btns">
            <div class="se-see-info cp" @click="getInfo(item.id)">查看详情</div>
            <div
              class="se-see-info cp se-m-t-30"
              @click="
                isShowComment(item.id, item.statisticalChartVo.evaluateNum)
              "
            >
              学员评价
            </div>
          </div>
        </div>
      </div>
      <div class="se-flex-h-c se-m-t-20">
        <el-pagination
          background
          @current-change="currentChange"
          :current-page="pageNum"
          :page-size="pageSize"
          layout="prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </template>
    <!-- 查看详情 -->
    <template v-if="type === 2">
      <courseware-info :courseId="courseId" @goBack="goBack"></courseware-info>
    </template>
    <!-- 上传课件 -->
    <template v-if="type === 3">
      <upload-courseware
        :auditStatusType="auditStatusType"
        :courseId="courseId"
        @back="back"
        @goHome="goHome"
      ></upload-courseware>
    </template>
    <!-- 评价列表对话框 -->
    <el-dialog title="学员评价列表" :visible.sync="visible">
      <div class="se-list">
        <div class="se-item" v-for="(item, i) in styMyCourses" :key="i">
          <evaluate-item :item="item"></evaluate-item>
        </div>
        <div class="se-flex-h-c se-m-t-20">
          <el-pagination
            background
            @current-change="currentChangeCom"
            :current-page="pageNumCom"
            :page-size="3"
            layout="prev, pager, next"
            :total="totalCom"
          >
          </el-pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import coursewareInfo from "./coursewareInfo.vue";
import uploadCourseware from "./uploadCourseware.vue";
import evaluateItem from "../../course-info/components/evaluateItem.vue";

export default {
  components: {
    coursewareInfo,
    uploadCourseware,
    evaluateItem,
  },

  data() {
    return {
      activeIndex: 0,
      type: 1,
      form: {},
      courseFiles: [],
      tabs: [
        {
          id: 0,
          name: "全部",
          value: undefined,
        },
        {
          id: 1,
          name: "待审核",
          value: 1,
        },
        {
          id: 2,
          name: "审核驳回",
          value: 2,
        },
        {
          id: 3,
          name: "审核通过",
          value: 3,
        },
      ],
      auditStatus: 0, //0:无需审核,1:待审核,2:审核驳回,3:审核通过
      courseId: "",
      pageNum: 1,
      pageSize: 5,
      total: 0,
      loading: false,
      auditStatusType: "",
      styMyCourses: [],
      visible: false,
      pageNumCom: 1,
      totalCom: 0,
    };
  },

  watch: {
    $route: {
      immediate: true,
      handler() {
        if (this.$route.query.type) {
          //需要监听的参数
          console.log(this.$route.query.type, "type");
          this.type = Number(this.$route.query.type);
        }
      },
    },
  },

  created() {
    this.getMyCourseFiles();
    if (this.$route.query.from === "sysMsg") {
      this.getInfo(this.$route.query.id);
    }
    this.courseId = this.$route.query.courseId;
    this.type = Number(this.$route.query.type);
    if (this.$route.query.auditStatusType === "edit") {
      this.auditStatusType = "edit";
    }
  },

  methods: {
    async uploadCourse() {
      let token = localStorage.getItem("token");
      if (token) {
        const user = await this.$http.get(
          "server/portal/personCenter/getUserDetails"
        );
        await this.$store.dispatch("setUserInfo", user.data);
        if (user.data.teacherEnabled === "0") {
          this.$message.info("您的讲师身份已关闭,无法上传课件,请联系管理员");
          return;
        }
        let path = this.$router.history.current.path;
        this.$router.push({
          path,
          query: { defaultActive: "6", type: 3, auditStatusType: "add" },
        });
        this.type = 3;
        this.auditStatusType = "add";
      } else {
        this.$message.info("请先登录");
      }
    },

    // 分页回调
    currentChange(val) {
      this.pageNum = val;
      this.getMyCourseFiles();
    },

    goHome() {
      this.type = 1;
      this.getMyCourseFiles();
    },

    getInfo(id) {
      let path = this.$router.history.current.path;
      this.$router.push({
        path,
        query: { defaultActive: "6", type: 2, courseId: id },
      });
      this.courseId = id;
      this.type = 2;
    },

    goBack(value) {
      console.log(value, "value");
      let path = this.$router.history.current.path;
      this.$router.push({
        path,
        query: {
          defaultActive: "6",
          type: value.type,
          auditStatusType: value.auditStatusType,
          courseId: value.courseId,
        },
      });
      this.type = value.type;
      this.auditStatusType = value.auditStatusType;
      this.courseId = value.courseId;
    },

    back(value) {
      let path = this.$router.history.current.path;
      this.$router.push({ path, query: { defaultActive: "6", type: 1 } });
      this.type = 1;
    },

    changeTab(item, index) {
      this.courseFiles = [];
      this.activeIndex = index;
      this.auditStatus = item.value;
      this.getMyCourseFiles();
    },

    //获取我的课件
    getMyCourseFiles() {
      this.loading = true;
      this.$http
        .get(
          `server/portal/personCenter/myCoursewareList/${
            this.auditStatus ? this.auditStatus : ""
          }`,
          {
            pageNum: this.pageNum,
            pageSize: this.pageSize,
          }
        )
        .then((res) => {
          this.courseFiles = res.rows;
          this.total = res.total;
        });
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },

    currentChangeCom(val) {
      this.styMyCourses = [];
      this.pageNumCom = val;
      this.getCourseContentList();
    },

    getCourseContentList() {
      this.$http
        .get(`server/portal/home/getCourseContent/${this.courseId}?planId=`, {
          pageSize: 3,
          pageNum: this.pageNumCom,
        })
        .then((res) => {
          this.styMyCourses = res.data.styMyCourses;
          // this.visible = [];
          this.totalCom = res.data.total;
        });
    },

    isShowComment(id, num) {
      if (num === 0) return this.$message.info("暂无评论");
      this.courseId = id;
      this.getCourseContentList();
      this.visible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.se-btn {
  width: 128px;
  height: 35px;
  border-radius: 16px;
  line-height: 35px;
  text-align: center;
  font-size: 16px;
  background-color: #f6f7f9;
}

.active {
  box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.09);
  color: #f41539;
  background-color: #fff;
}

.se-start-test {
  width: 124px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background-color: #e44352;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 400;
  color: #ffffff;
}

.se-see-info {
  border: 1px solid #999999;
  border-radius: 5px;
  width: 110px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  background-color: #fff;
}

/deep/ .se-dialog .el-dialog__header {
  padding: 0;
}

/deep/ .se-dialog .el-dialog__body {
  padding: 0;
}

/deep/ .se-dialog .el-dialog {
  border-radius: 11px 11px 0 0;
}

.course-status {
  width: 60px;
  height: 30px;
  img {
    width: 100%;
  }
}

.auditStatus-0 {
  width: 60px;
  height: 20px;
  text-align: center;
  border: 1px solid #2bbd5b;
  color: #2bbd5b;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.auditStatus-1 {
  width: 60px;
  height: 20px;
  text-align: center;
  border: 1px solid #f0760a;
  color: #f0760a;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.auditStatus-2 {
  width: 60px;
  height: 20px;
  text-align: center;
  border: 1px solid #e44352;
  color: #e44352;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.auditStatus-3 {
  width: 60px;
  height: 20px;
  text-align: center;
  border: 1px solid #2bbd5b;
  color: #2bbd5b;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.se-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #666666;
  margin: 0 15px;
}

.btns {
  display: flex;
  flex-direction: column;
  padding-left: 30px;
}

.se-item {
  // border-bottom: 1px solid #f1f1f1;
  padding: 20px 0;
}
</style>
